import React, { useState } from 'react';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { FormControl, RadioGroup, FormControlLabel, Radio, Button, Box, Typography } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Space } from "antd";
import { checkComponentPermission } from '../../../../../helpers/utilities';


export const FilterProductGroup = (props) => {
    const { customerDetails, customObject, topBar, handleCloseMobile, productGroupDetails, customerGroupdetails, handleSideFilter, roleManagement, topBarView } = props;
    const [mobileFilter, setMobileFilter] = useState(() => {
        return { ...topBar };
    });
    const classes = customStyles();

    const handleTypeChange = (value) => {
        setMobileFilter({
            ...mobileFilter, type: value
        })
    }

    const handleMobileSubmit = (e) => {
        e.preventDefault();
        handleSideFilter(mobileFilter);
    }

    return (
        <Box component='form'
            autoComplete='off'
            onSubmit={(e) => handleMobileSubmit(e)}
            className={clsx(classes.customForm, classes.removeUnderline)}>
            <div>
                {
                    <>
                        <Typography variant={'h6'} className={clsx(classes.margin15b, classes.textFieldLableColorCustom, classes.fonSize16, 'MuiInputLabel-shrink')}>Customer Specification - Filter</Typography>
                        {
                            roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Price', 'Action', 'Customer specification Filter') &&
                            <>
                                <FormControl
                                    className={clsx(classes.customRadioButton)}
                                    variant={'standard'}
                                    fullWidth >
                                    <RadioGroup
                                        row
                                        value={mobileFilter?.type}
                                        onChange={(e) => handleTypeChange(e.target.value)}>
                                        <FormControlLabel
                                            value="All"
                                            control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="All" />
                                        <FormControlLabel
                                            value="SPECIFIC"
                                            control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Customer Specific" />
                                        <FormControlLabel
                                            value="GROUP"
                                            control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Group" />
                                    </RadioGroup>
                                </FormControl>
                                {
                                    mobileFilter?.type !== 'All' && <>
                                        {
                                            mobileFilter?.type === 'GROUP' ?
                                                <AutoCompleteComponent
                                                    name={"All Customers Group"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerGroupdetails}

                                                    customClasses={clsx(classes.margin10t, classes.SalesPriceProduct)}
                                                    parentValue={customObject(customerGroupdetails, mobileFilter?.customerGroupId)}
                                                    position={"bottom"}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setMobileFilter({
                                                                ...mobileFilter, customerGroupId: ''
                                                            });
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        setMobileFilter({
                                                            ...mobileFilter, customerGroupId: data.id
                                                        });
                                                    }}
                                                /> : <AutoCompleteComponent
                                                    name={"All Customers"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerDetails}
                                                    customClasses={clsx(classes.margin10t)}
                                                    parentValue={customObject(customerDetails, mobileFilter?.customerId)}
                                                    position={"bottom"}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setMobileFilter({
                                                                ...mobileFilter, customerId: ''
                                                            });
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        setMobileFilter({
                                                            ...mobileFilter, customerId: data.id
                                                        });
                                                    }}
                                                />
                                        }
                                    </>
                                }
                            </>
                        }
                    </>
                }
                {
                    roleManagement !== '' && checkComponentPermission('Customer Sales Price', 'Action', 'Product Group Filter') &&
                    <>
                        <Typography variant={'h6'} className={clsx(classes.margin20t, classes.fonSize16, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')}>Product Group - Filter</Typography>
                        <AutoCompleteComponent
                            name={"All Product Group"}
                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                            details={productGroupDetails}
                            customClasses={clsx(classes.SalesPriceProduct)}
                            parentValue={customObject(productGroupDetails, mobileFilter?.productGroupId)}
                            position={"bottom"}
                            onChangeText={(data) => {
                                if (data === '') {
                                    setMobileFilter({
                                        ...mobileFilter, productGroupId: ''
                                    });
                                }
                            }}
                            onChange={(data) => {
                                setMobileFilter({
                                    ...mobileFilter, productGroupId: data.id
                                });
                            }}
                        />
                    </>
                }
                {/* <Row>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                        <Typography variant={'h6'} className={clsx(classes.margin20t, classes.fonSize16, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')}>Date - Filter</Typography>
                    </Col>
                    <Col xxl={11} xl={11} lg={11} md={11} sm={11} xs={11} >
                        {
                            roleManagement !== '' && checkComponentPermission('Customer Sales Price', 'Action', 'Date Filter') &&
                            <div className={clsx(classes.dateFilterdateAdjustMobile, classes.paddingLeft10P)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        allowKeyboardControl={false}
                                        slotProps={{ textField: { variant: 'standard', } }}
                                        value={mobileFilter?.startDate}
                                        label="From Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,

                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue, newError) => {
                                            if (newError?.validationError) {
                                                setMobileFilter({
                                                    ...mobileFilter, startDate: null
                                                });
                                            } else {
                                                setMobileFilter({
                                                    ...mobileFilter, startDate: newValue
                                                });
                                            }
                                        }}
                                        renderInput={(params) => <TextField autoComplete='one-time-code' {...params} />}
                                    />
                                </LocalizationProvider>
                            </div>
                        }
                    </Col>
                    <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}></Col>
                    <Col xxl={11} xl={11} lg={11} md={11} sm={11} xs={11}>
                        {
                            roleManagement !== '' && checkComponentPermission('Customer Sales Price', 'Action', 'Date Filter') &&
                            <div className={clsx(classes.dateFilterdateAdjustMobile)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        allowKeyboardControl={false}
                                        value={mobileFilter?.endDate}
                                        minDate={new Date(mobileFilter?.startDate)}
                                        label="To Date"
                                        slotProps={{ textField: { variant: 'standard', } }}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue, newError) => {
                                            if (newError?.validationError) {
                                                setMobileFilter({
                                                    ...mobileFilter, endDate: null
                                                });
                                            } else {
                                                setMobileFilter({
                                                    ...mobileFilter, endDate: newValue
                                                });
                                            }
                                        }}
                                        renderInput={(params) => <TextField autoComplete='one-time-code' {...params} />}
                                    />
                                </LocalizationProvider>
                            </div>
                        }
                    </Col>
                </Row> */}
            </div>

            <div className={clsx(classes.btnParent)}>
                <Space direction="horizontal" align="center"
                    size={[10, 10]}>
                    <Button
                        key="ok"
                        color="primary"
                        variant="contained"
                        type="submit"
                        className={classes.modalBtn}
                    >Ok</Button>
                    <Button
                        key="cancel"
                        color="primary"
                        variant="contained"
                        onClick={() => handleCloseMobile()}
                        className={clsx(classes.AddMoreBtn)}
                    >Cancel</Button>
                </Space>
            </div>
        </Box>
    )
}                 